import { InjectionToken } from "@angular/core";
import { ValidatorFn, Validators } from '@angular/forms';
import { USStates } from '../utils/us-states';
import { auStates } from '../utils/au-states';
import { resolveByCountry } from './country-resolver';

export const STATE_PROVINCE_TOKEN = new InjectionToken<string[]>('StateProvinceToken');

export const STATE_PROVINCE_VALIDATOR_TOKEN = new InjectionToken<ValidatorFn[]>('StateProvinceValidatorToken');

export const US_STATE_PROVINCE_VALIDATORS: ValidatorFn[] = [Validators.required, Validators.minLength(2), Validators.maxLength(2)];

export const AU_STATE_PROVINCE_VALIDATORS: ValidatorFn[] = [Validators.required, Validators.minLength(2), Validators.maxLength(3)];

/** Resolves the state/province list for the given country code. */
export function stateProvinceListFor(country: string | undefined | null, productDefault: string[]): string[] {
    return resolveByCountry(country, USStates, auStates, productDefault);
}

/** Resolves the state/province validators for the given country code. */
export function stateProvinceValidatorsFor(country: string | undefined | null, productDefault: ValidatorFn[]): ValidatorFn[] {
    return resolveByCountry(country, US_STATE_PROVINCE_VALIDATORS, AU_STATE_PROVINCE_VALIDATORS, productDefault);
}